import {ORDERS} from "../../Config/ApiUrl";
import {actionColumn, htmlColumn} from "../../Helpers/TableCommonColumn";
import {createdFilter, statusesFilter} from "../../Helpers/TableFIlter";
import {numberWithCurrencySymbol as numberFormatter} from "../../Helpers/Helpers";
import MemoizeMixins from "./MemoizeMixins";
import Vue from "vue";
import {urlGenerator} from "../../Helpers/AxiosHelper";

const subTotal = (products) => products.reduce((
    total, product) => total + Number(product?.pivot?.price),
    0
);

const discount = (products, row) => products.reduce(
    (total, product) => total + Number(product?.pivot?.discount), 0
) + Number(row.discount)

export default {
    mixins: [MemoizeMixins],
    data() {
        return {
            options: {
                name: this.$allLabel('orders'),
                url: ORDERS,
                responsive: true,
                columns: [
                    {
                        title: this.$t('order_number'),
                        type: 'expandable-column',
                        key: 'order_number',
                        className: 'success',
                        componentName: 'app-expandable-order-details',
                        showIcon: 'corner-right-down',
                        hideIcon: 'corner-right-up',
                        modifier: (value, row) => {
                            return {
                                visible: true,
                                expandable: true,
                                title: value
                            };
                        }
                    },
                    {
                        title: this.$t('customer'),
                        type: 'expandable-column',
                        key: 'user',
                        className: 'info',
                        componentName: 'app-expandable-order-user',
                        showIcon: 'corner-right-down',
                        hideIcon: 'corner-right-up',
                        modifier: (value, row) => {
                            return {
                                visible: true,
                                expandable: true,
                                title: value?.full_name
                            };
                        }
                    },
                    htmlColumn(this.$t('payment_method'), 'payment_method', v => this.$t(v)),
                    htmlColumn(
                        this.$t('sub_total'),
                        'products',
                        (products, row) => numberFormatter(
                            this.memoize(`product-price-${row.id}`, () => subTotal(products))
                        )
                    ),
                    htmlColumn(
                        this.$t('discount'),
                        'products',
                        (products, row) => numberFormatter(
                            this.memoize(`discount-price-${row.id}`, () => discount(products, row))
                        )
                    ),
                    htmlColumn(this.$t('shipping_cost'), 'shipping_cost', numberFormatter),
                    htmlColumn(this.$t('total'), 'products', (products, row) => {
                        return numberFormatter((Number(this.getMemoized(`product-price-${row.id}`))
                            - Number(this.getMemoized(`discount-price-${row.id}`)))
                            + Number(row.shipping_cost))
                    }),
                    {
                        title: this.$t('products'),
                        type: 'expandable-column',
                        key: 'products',
                        className: 'secondary',
                        componentName: 'app-expandable-order-products',
                        showIcon: 'corner-right-down', // not required
                        hideIcon: 'corner-right-up', // not required
                        modifier: (value, row) => {
                            return {
                                visible: true,
                                expandable: true,
                                title: value.length
                            };
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'expandable-column',
                        key: 'status',
                        componentName: 'app-expandable-order-status',
                        showIcon: 'corner-right-down',
                        hideIcon: 'corner-right-up',
                        modifier: (value, row) => {
                            return {
                                visible: true,
                                expandable: true,
                                title: value.translated_name,
                                className: value.class
                            };
                        }
                    },
                    actionColumn('')
                ],
                filters: [
                    createdFilter(),
                ],
                actionType: "default",
                actions: [
                    {
                        title: Vue.prototype.$t('View invoice'),
                        key: "pdf",
                        name: "pdf",
                        url: urlGenerator(ORDERS),
                        icon: 'file-text',
                        modifier: row => this.$can('view_order_invoice'),
                    },
                ],
                rowLimit: 10,
                paginationType: "pagination",
                showCount: true,
                showClearFilter: true,
                showFilterBy: true,
            },
        }
    },
    async mounted() {
        this.options.filters.push(await statusesFilter('order'));
    }
}